import { gql } from "@apollo/client";

const AUDIENCE_CONTACT_FIELD_FIELDS = gql`
  fragment AudienceContactFieldFields on AudienceContactField {
    id
    name
    displayName
    type
    typeParameters {
      maxLength
      values
    }
    isEditable
    createdAt
    updatedAt
  }
`;

export const GET_AUDIENCE_CONTACT_FIELDS = gql`
  ${AUDIENCE_CONTACT_FIELD_FIELDS}
  query getAudienceContactFields($input: GetAudienceContactFieldsInput!) {
    getAudienceContactFields(input: $input) {
      ...AudienceContactFieldFields
    }
  }
`;

export const DELETE_AUDIENCE_CONTACT_FIELD = gql`
  mutation deleteAudienceContactField(
    $input: DeleteAudienceContactFieldInput!
  ) {
    deleteAudienceContactField(input: $input) {
      success
    }
  }
`;

export const CREATE_CONTACT_FIELD = gql`
  ${AUDIENCE_CONTACT_FIELD_FIELDS}
  mutation createAudienceContactField(
    $input: CreateAudienceContactFieldInput!
  ) {
    createAudienceContactField(input: $input) {
      ...AudienceContactFieldFields
    }
  }
`;

export const UPDATE_CONTACT_FIELD = gql`
  ${AUDIENCE_CONTACT_FIELD_FIELDS}
  mutation updateAudienceContactField(
    $input: UpdateAudienceContactFieldInput!
  ) {
    updateAudienceContactField(input: $input) {
      ...AudienceContactFieldFields
    }
  }
`;

export const ENQUEUE_AUDIENCE_CONTACT_SEARCH = gql`
  mutation enqueueAudienceContactSearch(
    $input: EnqueueAudienceContactSearchInput!
  ) {
    enqueueAudienceContactSearch(input: $input) {
      success
    }
  }
`;

const AUDIENCE_SEARCH_FILTER_FIELDS = gql`
  fragment AudienceSearchFilterFields on AudienceSearchFilter {
    id
    subaccountId
    tenantId
    audienceId
    name
    type
    searchBody {
      targetGroups {
        clauses {
          fieldName
          fieldType
          filterCategory
          filterConfig {
            centerZips
            radius
          }
          filterOperation
          value
          values
        }
        dateFilter {
          endDate
          key
          startDate
        }
      }
    }
    searchJob {
      status
      result {
        contactCount
        calculatedAt
      }
    }
    createdAt
    createdByUserId
    createdBy {
      id
      fullName
    }
    updatedAt
    deletedAt
  }
`;

const AUDIENCE_SEARCH_RESULT_FIELDS = gql`
  fragment AudienceSearchResultFields on AudienceSearchResult {
    id
    subaccountId
    tenantId
    audienceId
    audienceContactId
    createdAt
    updatedAt
    phoneNumber
    fields {
      name
      displayName
      type
      value
    }
  }
`;

export const GET_AUDIENCE_SEARCH_USER_FILTER = gql`
  ${AUDIENCE_SEARCH_FILTER_FIELDS}
  query getAudienceSearchUserFilter($input: GetAudienceSearchUserFilterInput!) {
    getAudienceSearchUserFilter(input: $input) {
      ...AudienceSearchFilterFields
    }
  }
`;

export const LIST_AUDIENCE_SEARCH_FILTERS = gql`
  ${AUDIENCE_SEARCH_FILTER_FIELDS}
  query listAudienceSearchFilters($input: ListAudienceSearchFiltersInput!) {
    listAudienceSearchFilters(input: $input) {
      audienceSearchFilters {
        ...AudienceSearchFilterFields
      }
      totalCount
    }
  }
`;

export const CREATE_AUDIENCE_SEARCH_FILTER = gql`
  ${AUDIENCE_SEARCH_FILTER_FIELDS}
  mutation CreateAudienceSearchFilter(
    $input: CreateAudienceSearchFilterInput!
  ) {
    createAudienceSearchFilter(input: $input) {
      ...AudienceSearchFilterFields
    }
  }
`;

export const UPDATE_AUDIENCE_SEARCH_FILTER = gql`
  ${AUDIENCE_SEARCH_FILTER_FIELDS}
  mutation UpdateAudienceSearchFilter(
    $input: UpdateAudienceSearchFilterInput!
  ) {
    updateAudienceSearchFilter(input: $input) {
      ...AudienceSearchFilterFields
    }
  }
`;

export const DELETE_AUDIENCE_SEARCH_FILTER = gql`
  mutation DeleteAudienceSearchFilter(
    $input: DeleteAudienceSearchFilterInput!
  ) {
    deleteAudienceSearchFilter(input: $input) {
      success
    }
  }
`;

export const UPSERT_AUDIENCE_SEARCH_USER_FILTER = gql`
  ${AUDIENCE_SEARCH_FILTER_FIELDS}
  mutation upsertAudienceSearchUserFilter(
    $input: UpsertAudienceSearchUserFilterInput!
  ) {
    upsertAudienceSearchUserFilter(input: $input) {
      ...AudienceSearchFilterFields
    }
  }
`;

export const LIST_AUDIENCE_SEARCH_RESULTS = gql`
  ${AUDIENCE_SEARCH_RESULT_FIELDS}
  query listAudienceSearchResults($input: ListAudienceSearchResultsInput!) {
    listAudienceSearchResults(input: $input) {
      audienceSearchResults {
        ...AudienceSearchResultFields
      }
      totalCount
    }
  }
`;
